import alt from 'components/Dispatcher';
import {Store, StoreMethods} from '@store/@types/alt';
import RepCoachingActions, {
  RepCoachingActionsInterface,
} from '@store/coaching-plans/rep/RepCoachingActions';
import CoachingPlan, {PlanId} from 'records/CoachingPlan';
import {Int} from '@store/@types/util';
import {List, Map} from 'immutable';
import {UserId} from 'records/User';
import {CoachingPlanVelocity} from 'records/CoachingPlanVelocity';
import {associateBy} from 'utils/associateBy';

interface RepCoachingStoreState {
  plansByRep: Map<UserId, List<CoachingPlan>>;
  // TODO Maybe move to main coaching store?
  timeSpentByPlan: Map<PlanId, Int>;
  // TODO Maybe move to main coaching store?
  velocityMap: Map<PlanId, CoachingPlanVelocity>;
}

class RepCoachingStore
  extends Store<RepCoachingStoreState>
  implements StoreMethods<RepCoachingActionsInterface>
{
  constructor() {
    super();
    this.state = {
      plansByRep: Map(),
      timeSpentByPlan: Map(),
      velocityMap: Map(),
    };
    this.bindActions(RepCoachingActions);
  }

  fetchRepPlans(): void {}
  fetchRepPlansError(error: Error): void {
    console.error(error);
  }
  fetchRepPlansSuccess(plans: List<CoachingPlan>): void {
    const plansByRep = plans.groupBy(p => p.recipient.id);
    this.setState({plansByRep});
  }

  fetchTimeSpent(): void {}
  fetchTimeSpentError(error: Error): void {
    console.error(error);
  }
  fetchTimeSpentSuccess(timeSpent: Map<PlanId, Int>): void {
    this.setState({timeSpentByPlan: this.state.timeSpentByPlan.merge(timeSpent)});
  }

  fetchVelocity(): void {}
  fetchVelocityError(error: Error): void {
    console.error(error);
  }
  fetchVelocitySuccess(velocities: List<CoachingPlanVelocity>): void {
    this.setState({
      velocityMap: associateBy(velocities, v => v.planId, this.state.velocityMap),
    });
  }
}

export default alt.createStore(RepCoachingStore);
